import React from 'react';
import Spinner from 'components/shared/Spinner';
import { useStores } from 'hooks';
import { Wrapper } from './Styles';

const SoftLoadingOverlay = () => {
  const {
    WebSocketStore: { softLoadingVisible },
  } = useStores();

  if (softLoadingVisible) {
    return (
      <Wrapper><Spinner size={70} /></Wrapper>
    );
  }
  return null;
};

export default SoftLoadingOverlay;
